import * as React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import SendIcon from '@mui/icons-material/Send';
import { Badge, Grid, IconButton, Stack, Typography } from '@mui/material';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import SmsRoundedIcon from '@mui/icons-material/SmsRounded';
import SmsFailedRoundedIcon from '@mui/icons-material/SmsFailedRounded';
import { FacebookCircularProgress } from './CustomProgressbars';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import AutorenewIcon from '@mui/icons-material/Autorenew';

export default function BackgroundTaskList() {
    const [openInvites, setOpenInvites] = React.useState(false);
    const [openUploads, setOpenUploads] = React.useState(false);
    const meetingAlerts = useSelector(state => state.utilities.backGroundTask.meetingAlerts)
    const meetingFolderUpload = useSelector(state => state.utilities.backGroundTask.meetingFolderUpload)
    const [detailsOpened, setDetailsOpened] = React.useState([]);
    const dispatch = useDispatch();



    const handleClickInvites = () => {
        setOpenInvites(!openInvites);
    };
    const handleClickUpload = () => {
        setOpenUploads(!openUploads);
    };
    const send = (url, body, companyId, companyCode) => axios.post(url, body, {
        headers: {
            'Company-Code': companyCode,
            'Company-Id': companyId
        }
    })
    const uploadAgendaResource = (url, meetingFolder, file, companyId, companyCode) => axios.post(url, { folder: meetingFolder, files: [file] }, {
        headers: {
            'Company-Code': companyCode,
            'Company-Id': companyId
        }
    })
    const getUserResourcePermissions = (meetingFolder) => axios.get(`/resources/${meetingFolder}/user-permissions`);


    const handleResend = (alert) => {
        dispatch({ type: "RESEND_MEETING_ALERT_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'ongoing' } });
        send(`/meetings/invitation/${alert.id}`, alert.body, alert.companyId, alert.companyCode)
            .then(res => {
                if (res.data.code === 200)
                    dispatch({ type: "SUCCESS_MEETING_ALERT_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'success' } });
                else
                    dispatch({ type: "FAILED_MEETING_ALERT_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'failed', url: '/meetings/invitation/', id: alert.id, body: alert.body } })
            })
            .catch(() => dispatch({ type: "FAILED_MEETING_ALERT_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'failed', url: '/meetings/invitation/', id: alert.id, body: alert.body } }))
    }
    const handleResendFolder = (alert) => {
        dispatch({ type: "RESEND_MEETING_UPLOAD_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'ongoing' } });
        getUserResourcePermissions(alert.meetingFolder)
            .then(permission => {
                if (permission && permission.data && permission.data.upload) {
                    uploadAgendaResource(alert.uploadAgendaResourceUrl, alert.meetingFolder, alert.file, alert.companyId, alert.companyCode)
                        .then(resources => {
                            if (resources || resources.data.length > 0) {
                                dispatch({ type: "SUCCESS_MEETING_UPLOAD_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'success' } });
                            } else {
                                dispatch({ type: "FAILED_MEETING_UPLOAD_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'failed', uploadAgendaFilesUrl: '/meetings/agenda/files/', uploadAgendaResourceUrl: '/meetings/agenda/resource_files/' + alert.id, id: alert.id, meetingFolder: alert.meetingFolder, file: alert.file } });
                            }
                        })
                        .catch(() => {
                            dispatch({ type: "FAILED_MEETING_UPLOAD_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'failed', uploadAgendaFilesUrl: '/meetings/agenda/files/', uploadAgendaResourceUrl: '/meetings/agenda/resource_files/' + alert.id, id: alert.id, meetingFolder: alert.meetingFolder, file: alert.file } })
                        })
                } else {
                    dispatch({ type: "FAILED_MEETING_UPLOAD_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'failed', uploadAgendaFilesUrl: '/meetings/agenda/files/', uploadAgendaResourceUrl: '/meetings/agenda/resource_files/' + alert.id, id: alert.id, meetingFolder: alert.meetingFolder, file: alert.file, type: 'Permission' } })
                }
            }).catch(() => {
                dispatch({ type: "FAILED_MEETING_UPLOAD_BACK_GROUND_TASK", payload: { name: alert.name, meeting: alert.meeting, status: 'failed', uploadAgendaFilesUrl: '/meetings/agenda/files/', uploadAgendaResourceUrl: '/meetings/agenda/resource_files/' + alert.id, id: alert.id, meetingFolder: alert.meetingFolder, file: alert.file, type: 'Permission' } })
            })

    }

    return (
        <List
            sx={{
                width: '100%',
                maxWidth: '100%',
                maxHeight: '90vh',
                padding: 0
            }}
            component="nav"
            aria-labelledby="background-tasks"
        >
            {
                meetingAlerts.length > 0 && meetingAlerts.filter(x => x.status !== 'success').length > 0 &&
                (
                    <>
                        <ListItemButton
                            onClick={handleClickInvites}
                            sx={{
                                bgcolor: 'transparent'
                            }}
                        >
                            <ListItemIcon>
                                <Badge badgeContent={meetingAlerts.filter(x => x.status === 'failed').length} color='error'>
                                    <SendIcon
                                        sx={{
                                            color: '#ffffff'
                                        }}
                                    />
                                </Badge>
                            </ListItemIcon>
                            <ListItemText
                                primary="Sending Meeting Invites"
                                primaryTypographyProps={{
                                    fontSize: 15,
                                    fontWeight: 'medium',
                                    lineHeight: '20px',
                                    mb: '2px',
                                    color: '#ffffff'

                                }}
                                secondary={meetingAlerts.filter(a => a.status !== 'success').map(x => x.name).toString()
                                }
                                secondaryTypographyProps={{
                                    noWrap: true,
                                    fontSize: 12,
                                    lineHeight: '16px',
                                    visibility: openInvites ? 'hidden' : 'visible',
                                    color: '#ffffff'

                                }}
                                sx={{ my: 0 }}
                            />
                            <KeyboardArrowDown
                                sx={{
                                    transform: openInvites ? 'rotate(-180deg)' : 'rotate(0)',
                                    transition: '0.2s',
                                    color: 'white'
                                }}
                            />
                        </ListItemButton>
                        <Collapse in={openInvites} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding sx={{ bgcolor: '#06060661' }}>
                                {
                                    meetingAlerts.filter(x => x.status !== 'success').map((alert, i) => (
                                        <>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                key={i}
                                                onClick={() => {
                                                    if (!detailsOpened.some(detail => detail.name === alert.name && detail.id === i)) {
                                                        setDetailsOpened([...detailsOpened, { id: i, name: alert.name }])
                                                    } else {
                                                        setDetailsOpened(detailsOpened.filter(detail => !(detail.name === alert.name && detail.id === i)))
                                                    }
                                                }}
                                            >
                                                <Grid container direction='row'>
                                                    <Grid item xs={1} sx={{ pt: .2 }}>
                                                        {alert.status === 'ongoing' ? <FacebookCircularProgress /> : alert.status === 'success' ? <SmsRoundedIcon sx={{ color: 'green' }} size="small" /> : <SmsFailedRoundedIcon color='error' size="small" />}
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <ListItemText
                                                            sx={{
                                                                color: 'white',
                                                                opacity: .8,
                                                                whiteSpace: !detailsOpened.some(detail => detail.name === alert.name && detail.id === i) ? 'nowrap' : 'pre-wrap',
                                                            }}
                                                            primary={alert.name.toUpperCase()}
                                                            primaryTypographyProps={{
                                                                variant: 'subtitle2',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <ListItemText
                                                            sx={{ color: alert.status === 'failed' ? 'error' : '#1a90ff', opacity: .8 }}
                                                            primary={alert.status.toUpperCase()}
                                                            primaryTypographyProps={{
                                                                variant: 'subtitle2',
                                                                style: {
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                }
                                                            }}
                                                        />
                                                    </Grid>
                                                    {
                                                        alert.status === 'failed' &&
                                                        (
                                                            <Grid item xs={1} sx={{ pb: .2 }} >
                                                                <IconButton
                                                                    color="primary"
                                                                    aria-label="resend"
                                                                    size='small'
                                                                    onClick={() => handleResend(alert)}
                                                                >
                                                                    <AutorenewIcon />
                                                                </IconButton>
                                                            </Grid>
                                                        )
                                                    }
                                                </Grid>
                                            </ListItemButton>
                                            <Collapse in={detailsOpened.some(detail => detail.name === alert.name && detail.id === i)} timeout="auto" unmountOnExit>
                                                <Stack direction="column" sx={{ bgcolor: '#06060661', overflowY: 'auto', pl: 5, pt: 1, pb: 1 }}>
                                                    <Typography color="#ffffffc7" fontvariant="subtitle2"><u>Details</u></Typography>
                                                    <Typography color="#ffffffc7" variant="subtitle1">Meeting: {alert.meeting}</Typography>
                                                    <Typography color="#ffffffc7" variant='subtitle2'>Company: {alert.companyName}</Typography>
                                                </Stack>
                                            </Collapse>
                                        </>
                                    ))
                                }

                            </List>
                        </Collapse>
                    </>
                )
            }
            {
                meetingFolderUpload.length > 0 && meetingFolderUpload.filter(x => x.status !== 'success').length > 0 &&
                (
                    <>
                        <ListItemButton
                            onClick={handleClickUpload}
                            sx={{
                                bgcolor: 'transparent'
                            }}
                        >
                            <ListItemIcon>
                                <Badge badgeContent={meetingFolderUpload.filter(x => x.status === 'failed').length} color='error'>
                                    <FileOpenIcon
                                        sx={{
                                            color: '#ffffff'
                                        }}
                                    />
                                </Badge>
                            </ListItemIcon>
                            <ListItemText
                                primary="Uploading Meeting Files"
                                primaryTypographyProps={{
                                    fontSize: 15,
                                    fontWeight: 'medium',
                                    lineHeight: '20px',
                                    mb: '2px',
                                    color: '#ffffff'
                                }}
                                secondary={meetingFolderUpload.filter(a => a.status !== 'success').map(x => x.name).toString()
                                }
                                secondaryTypographyProps={{
                                    noWrap: true,
                                    fontSize: 12,
                                    lineHeight: '16px',
                                    visibility: openUploads ? 'hidden' : 'visible',
                                    color: '#ffffff'

                                }}
                                sx={{ my: 0 }}
                            />
                            <KeyboardArrowDown
                                sx={{
                                    transform: openUploads ? 'rotate(-180deg)' : 'rotate(0)',
                                    transition: '0.2s',
                                    color: 'white'
                                }}
                            />
                        </ListItemButton>
                        <Collapse in={openUploads} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding sx={{ bgcolor: '#06060661' }}>
                                {
                                    meetingFolderUpload.filter(x => x.status !== 'success').map((alert, i) => (
                                        <>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                key={i}
                                                onClick={() => {
                                                    if (!detailsOpened.some(detail => detail.name === alert.name && detail.id === i)) {
                                                        setDetailsOpened([...detailsOpened, { id: i, name: alert.name }])
                                                    } else {
                                                        setDetailsOpened(detailsOpened.filter(detail => !(detail.name === alert.name && detail.id === i)))
                                                    }
                                                }}
                                            >

                                                <Grid container direction='row'>
                                                    <Grid item xs={1} sx={{ pt: .2 }}>
                                                        {alert.status === 'ongoing' ? <FacebookCircularProgress /> : alert.status === 'success' ? <SmsRoundedIcon sx={{ color: 'green' }} size="small" /> : <SmsFailedRoundedIcon color='error' size="small" />}
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <ListItemText
                                                            sx={{
                                                                color: 'white',
                                                                opacity: .8,
                                                                whiteSpace: !detailsOpened.some(detail => detail.name === alert.name && detail.id === i) ? 'nowrap' : 'pre-wrap',
                                                            }}
                                                            primary={alert.name.toUpperCase()}
                                                            primaryTypographyProps={{
                                                                variant: 'subtitle2',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <ListItemText
                                                            sx={{ color: alert.status === 'failed' ? 'error' : '#1a90ff', opacity: .8 }}
                                                            primary={alert.status.toUpperCase()}
                                                            primaryTypographyProps={{
                                                                variant: 'subtitle2',
                                                                style: {
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                }
                                                            }}
                                                        />
                                                    </Grid>

                                                    {
                                                        alert.status === 'failed' &&
                                                        (
                                                            <Grid item xs={1} sx={{ pb: .2 }} >
                                                                <IconButton
                                                                    color="primary"
                                                                    aria-label="resend"
                                                                    size='small'
                                                                    onClick={() => handleResendFolder(alert)}
                                                                >
                                                                    <AutorenewIcon />
                                                                </IconButton>
                                                            </Grid>
                                                        )
                                                    }
                                                </Grid>
                                            </ListItemButton>
                                            <Collapse in={detailsOpened.some(detail => detail.name === alert.name && detail.id === i)} timeout="auto" unmountOnExit>
                                                <Stack direction="column" sx={{ bgcolor: '#06060661', overflowY: 'auto', pl: 5, pt: 1, pb: 1 }}>
                                                    <Typography color="#ffffffc7" fontvariant="subtitle2"><u>Details</u></Typography>
                                                    <Typography color="#ffffffc7" variant="subtitle1">Meeting: {alert.meeting}</Typography>
                                                    <Typography color="#ffffffc7" variant='subtitle2'>Company: {alert.companyName}</Typography>
                                                    <Typography color="#ffffffc7" variant='subtitle2'>Agenda: {alert.agendaName ?? ''}</Typography>
                                                    {alert.type && alert.type === "Permission" &&
                                                        <Typography color="error" variant='subtitle1'>Details: You Do not have permissions to upload in the current meeting pack</Typography>
                                                    }
                                                </Stack>
                                            </Collapse>
                                        </>
                                    ))
                                }

                            </List>
                        </Collapse>
                    </>
                )
            }
        </List>
    );
}
